import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import TextAvatar from 'src/components/TextAvatar/TextAvatar'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import Trns from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import styled, { css } from 'styled-components'

interface TeamAvatarsIconProps {
  users: UserListModel[] | undefined
  showPill?: boolean
}

const StyledPill = styled.div`
  display: flex;
  padding: 2px 4px;
  width: fit-content;
  justify-content: center;
  align-items: center;
  gap: 1px;
  border-radius: 5px;
  ${getFontCss(
    10,
    styleConstants.colors.black,
    styleConstants.fontFamilies.medium,
  )};
  background: var(--tags-grey-50, #ecedef);
`

const TeamAvatarsIcon: React.FC<TeamAvatarsIconProps> = (
  props,
): React.ReactElement => {
  let numUsers = (props.users?.length ?? 0) > 4 ? 3 : 4
  const additionalUsers = (props.users?.length ?? 0) - numUsers

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 7px;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-start;
        `}
      >
        {props.users?.map((user) => {
          numUsers--
          if (numUsers >= 0) {
            return (
              <UserAvatar
                key={user.id}
                css={css`
                  margin-top: -3px;
                  &:nth-child(n + 2) {
                    margin-left: -8px;
                  }
                  width: 20px;
                  height: 20px;
                `}
                user={user}
                size={AvatarSizes.Small}
              />
            )
          }
        })}
        {(props.users?.length ?? 0) > 4 && (
          <TextAvatar
            css={css`
              margin-top: -3px;
              &:nth-child(n + 2) {
                margin-left: -8px;
              }
              width: 20px;
              height: 20px;
            `}
            size={AvatarSizes.Small}
            text={'+' + additionalUsers}
          />
        )}
      </div>
      {props.showPill && (
        <div
          css={css`
            display: flex;
            flex-direction: column;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
          `}
        >
          <span
            css={css`
              margin-left: 8px;
              overflow: auto;
              text-overflow: ellipsis;
            `}
          >
            <StyledPill>
              <Trns source={'Team Budget'} />
            </StyledPill>
          </span>
        </div>
      )}
    </div>
  )
}

export default TeamAvatarsIcon
